/**
 * Registers a new block provided a unique name and an object defining its behavior.
 *
 * @see https://developer.wordpress.org/block-editor/developers/block-api/#registering-a-block
 */
import { registerBlockType, registerBlockVariation } from '@wordpress/blocks';

/**
 * Internal dependencies
 */
import Edit from './edit';
import save from './save';
import metadata from './block.json';
import BiconGridIcon from 'blockbite-icons/dist/BiconGrid';

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/developers/block-api/#registering-a-block
 */
registerBlockType(metadata.name, {
  /**
   * Used to construct a preview for the block to be shown in the block inserter.
   */
  example: {
    attributes: {
      message: 'Carousel',
    },
  },
  icon: BiconGridIcon,
  /**
   * @see ./edit.js
   */
  edit: Edit,

  /**
   * @see ./save.js
   */
  save,

  variations: [
    {
      name: 'static-content-carousel',
      isDefault: true,
      title: 'Static Content Carousel',
      description:
        'Create a Carousel block with static content, such as text and images.',
      attributes: { contentType: 'static' },
      innerBlocks: [
        [
          'blockbite/carousel-slide',
          {},
          [
            [
              'core/image',
              {
                url: 'https://via.placeholder.com/800x400?text=Image+1',
                alt: 'Image 1',
              },
            ],
          ],
        ],
      ],
    },
    {
      name: 'dynamic-content-carousel',
      title: 'Dynamic Content Carousel',
      description:
        'Create a Carousel block with dynamic content, such as a list of posts.',
      attributes: { contentType: 'dynamic' },
      innerBlocks: [
        [
          'core/query',
          {
            variation: 'dynamic-carousel-query',
            query: {
              categories: [1],
              orderby: 'date',
              order: 'desc',
              postsToShow: 3,
            },
          },
          [
            [
              'core/post-template',
              {
                variation: 'dynamic-carousel-template',
              },
            ],
          ],
        ],
      ],
    },
  ],
});
